import React, { Component } from 'react'
import styles from './styles.scss'

import { TimelineMax, TweenMax, Power3, Expo } from 'gsap'

import Cover from 'src/components/cover-img'

import raf from 'src/utils/raf'
import resize from 'src/utils/resize'
import values from 'src/values'
import config from 'src/config'
import components from 'src/utils/components'
import Scroller from 'src/utils/scroller'

export default class Memento extends Component {
  constructor(props) {
    super(props)

    this.key = `${this.props.type}-${Math.random()}`
  }

  componentDidMount() {
    Scroller.updateScrollHeight()
  }

  componentDidUpdate() {
    Scroller.updateScrollHeight()
  }

  render() {
    return (
      <div ref="component" className="component memento">
        <div className="wrapper-content">
          <div className="m-grid-12 grid-wrapper">
            <div ref="blockImgContainer" className="block-img-container">
              <div ref="overflowCover" className="overflow-cover">
                <Cover
                  ref="cover"
                  src={`${process.env.PUBLIC_URL}/img/${this.props.img}`}
                />
              </div>
            </div>
            <div
              ref="content"
              style={
                this.props.mobile &&
                this.props.mobile.contentStyle && {
                  ...this.props.mobile.contentStyle
                }
              }
              className="content">
              <p dangerouslySetInnerHTML={{ __html: this.props.content }} />
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/World/mobile/memento/index.js